import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const baseUrl = process.env.REACT_APP_BASE_URL;
const apikey = process.env.REACT_APP_API_KEY;

export const settingsApi = createApi({
  reducerPath: "settingsApi",
  baseQuery: fetchBaseQuery({
    baseUrl,
    credentials: "include",
    prepareHeaders: (headers) => {
      headers.set("apiKey", apikey);
      const token = JSON.parse(localStorage.getItem("loginData"))?.token;
      if (token) headers.set("Authorization", token);
      return headers;
    },
  }),
  tagTypes: ["AppSettings"],
  endpoints: (builder) => ({
    getAppSettings: builder.query({
      query: () => ({
        url: `/admin/getAppSettings`,
        method: "GET",
      }),
      providesTags: ["AppSettings"],
    }),

    startAnnualEmailVerification: builder.mutation({
      query: (body) => ({
        url: `/admin/startAnnualEmailVerification`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["AppSettings"],
    }),
  }),
});

export const {
  useGetAppSettingsQuery,
  useStartAnnualEmailVerificationMutation,
} = settingsApi;
